import actions from "./actions";

const initState = {
    auditResult: [],
    loading: false,
    error: null,
    buttonLoading: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_AUDIT_REPORT:
            return {
                ...state,
                loading: true,
                error: null,
                buttonLoading :true
            };
        case actions.GET_AUDIT_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                auditResult: action.auditResult,
            };
        case actions.GET_AUDIT_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case actions.RESET_AUDIT_REPORT_MESSAGE:
            return {
                ...state,
                loading: false,
                error: null,
                buttonLoading: false,
            };
        default:
            return state;
    }
}